<template>
  <section
    class="n-section-primary tw-flex tw-w-full tw-flex-col !tw-pt-32 md:!tw-pt-44 xl:!tw-pt-60"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-grid tw-w-full tw-grid-cols-12 tw-items-start tw-justify-between">
      <div class="tw-col-span-12 tw-flex tw-flex-col md:tw-col-span-6 lg:tw-gap-y-4">
        <h1 class="tw-uppercase">{{ vars.jobTitleText }}</h1>
        <div class="tw-mt-4 tw-flex tw-items-center tw-gap-1">
          <span
            ><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.8395 5.06984C7.47244 3.43691 9.68718 2.51953 11.9965 2.51953C14.3058 2.51953 16.5206 3.43691 18.1535 5.06984C19.7864 6.70278 20.7038 8.91752 20.7038 11.2268C20.7038 13.5362 19.7864 15.7509 18.1535 17.3838L16.9665 18.5578C16.0918 19.4158 14.9565 20.5198 13.5605 21.8698C13.1409 22.2755 12.5801 22.5023 11.9965 22.5023C11.4129 22.5023 10.8521 22.2755 10.4325 21.8698L6.94151 18.4738C6.50217 18.0432 6.13484 17.6798 5.8395 17.3838C5.03092 16.5753 4.38951 15.6154 3.9519 14.559C3.5143 13.5026 3.28906 12.3703 3.28906 11.2268C3.28906 10.0834 3.5143 8.9511 3.9519 7.89468C4.38951 6.83825 5.03092 5.87837 5.8395 5.06984ZM17.0925 6.12984C16.4232 5.46056 15.6285 4.92967 14.754 4.56748C13.8795 4.2053 12.9422 4.0189 11.9957 4.01895C11.0491 4.019 10.1118 4.20548 9.23734 4.56775C8.36285 4.93003 7.56829 5.461 6.899 6.13034C6.22972 6.79969 5.69883 7.59431 5.33664 8.46883C4.97446 9.34335 4.78807 10.2806 4.78811 11.2272C4.78816 12.1738 4.97464 13.111 5.33692 13.9855C5.69919 14.86 6.23016 15.6546 6.8995 16.3238L8.3875 17.7918C9.20617 18.5925 10.2355 19.5925 11.4755 20.7918C11.6153 20.9269 11.8021 21.0023 11.9965 21.0023C12.1909 21.0023 12.3777 20.9269 12.5175 20.7918L15.9125 17.4918C16.3825 17.0312 16.7758 16.6418 17.0925 16.3238C18.444 14.9723 19.2033 13.1392 19.2033 11.2278C19.2033 9.31649 18.444 7.48341 17.0925 6.13184M11.9965 8.50084C12.3907 8.50084 12.7811 8.57849 13.1453 8.72936C13.5095 8.88022 13.8405 9.10135 14.1192 9.38011C14.398 9.65887 14.6191 9.98981 14.77 10.354C14.9209 10.7182 14.9985 11.1086 14.9985 11.5028C14.9985 11.8971 14.9209 12.2874 14.77 12.6517C14.6191 13.0159 14.398 13.3468 14.1192 13.6256C13.8405 13.9043 13.5095 14.1255 13.1453 14.2763C12.7811 14.4272 12.3907 14.5048 11.9965 14.5048C11.2099 14.4905 10.4605 14.1679 9.90928 13.6066C9.3581 13.0453 9.04929 12.29 9.04929 11.5033C9.04929 10.7167 9.3581 9.9614 9.90928 9.40007C10.4605 8.83874 11.2099 8.5162 11.9965 8.50184M11.9965 10.0018C11.5981 10.0018 11.2161 10.1601 10.9344 10.4418C10.6528 10.7234 10.4945 11.1055 10.4945 11.5038C10.4945 11.9022 10.6528 12.2842 10.9344 12.5659C11.2161 12.8476 11.5981 13.0058 11.9965 13.0058C12.388 12.9957 12.7601 12.8331 13.0334 12.5526C13.3068 12.2721 13.4598 11.896 13.4598 11.5043C13.4598 11.1127 13.3068 10.7365 13.0334 10.4561C12.7601 10.1756 12.388 10.0129 11.9965 10.0028"
                fill="black"
              />
            </svg>
          </span>
          <h6 class="tw-uppercase" style="color: var(--c-text_primary) !important">
            {{ vars.jobLocationText }}
          </h6>
        </div>
        <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
          <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
            <div
              v-for="feature in features"
              class="tw-p-3"
              style="background-color: var(--c-section_secondary); border-radius: var(--rounded)"
            >
              <h6>{{ feature.title }}</h6>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-col-span-12 md:tw-col-span-6">
        <div
          class="tw-mt-4 tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-5 tw-py-5 md:tw-flex-row md:tw-items-center md:tw-justify-end lg:tw-mt-8"
        >
          <div>
            <nuxt-link :to="vars.applyButtonLinkUrl" :external="true" class="n-btn n-primary">
              <div class="n-btn-container tw-w-full md:tw-w-auto">
                <div class="n-btn-group">
                  <div class="n-btn-t1">APPLY NOW</div>
                  <div class="n-btn-t2">APPLY NOW</div>
                </div>
              </div>
            </nuxt-link>
          </div>
          <div
            class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full"
            style="background-color: transparent; border: 1px solid var(--c-primary)"
            @click="onShared()"
          >
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.5386 3C19.9534 2.9998 19.3753 3.12802 18.845 3.37562C18.3147 3.62321 17.8452 3.98414 17.4697 4.43296C17.0941 4.88177 16.8216 5.40752 16.6713 5.97314C16.5211 6.53875 16.4968 7.13044 16.6002 7.70646L10.7786 11.7828C10.7495 11.8029 10.7216 11.8247 10.6949 11.848C10.1043 11.3863 9.39588 11.0999 8.65036 11.0214C7.90484 10.9429 7.15226 11.0754 6.47844 11.404C5.80462 11.7325 5.23669 12.2438 4.83939 12.8795C4.4421 13.5152 4.23145 14.2497 4.23145 14.9994C4.23145 15.749 4.4421 16.4836 4.83939 17.1193C5.23669 17.755 5.80462 18.2663 6.47844 18.5948C7.15226 18.9233 7.90484 19.0559 8.65036 18.9774C9.39588 18.8989 10.1043 18.6125 10.6949 18.1508C10.7215 18.1745 10.7495 18.1967 10.7786 18.2172L16.6002 22.2935C16.4273 23.2569 16.6137 24.2502 17.1241 25.0854C17.6344 25.9206 18.4333 26.5397 19.3694 26.8255C20.3055 27.1113 21.3139 27.0439 22.2037 26.6362C23.0935 26.2284 23.8029 25.5086 24.1976 24.613C24.5923 23.7173 24.645 22.708 24.3456 21.7762C24.0461 20.8443 23.4155 20.0546 22.5729 19.5565C21.7304 19.0584 20.7344 18.8865 19.7737 19.0734C18.8129 19.2603 17.954 19.7929 17.3595 20.5705L11.8469 16.712C12.0931 16.1926 12.2309 15.6129 12.2309 15C12.2309 14.3871 12.0931 13.8062 11.8469 13.288L17.3608 9.42831C17.7738 9.96895 18.3179 10.3953 18.9416 10.6671C19.5654 10.9388 20.2481 11.047 20.9253 10.9813C21.6024 10.9157 22.2517 10.6784 22.8116 10.2919C23.3715 9.90545 23.8236 9.38253 24.1251 8.77263C24.4266 8.16273 24.5676 7.48601 24.5347 6.80646C24.5017 6.1269 24.296 5.46697 23.937 4.88907C23.5779 4.31117 23.0774 3.8344 22.4828 3.50385C21.8881 3.17329 21.219 2.99988 20.5386 3ZM18.3848 7C18.3848 6.42876 18.6117 5.88093 19.0156 5.477C19.4195 5.07308 19.9674 4.84615 20.5386 4.84615C21.1099 4.84615 21.6577 5.07308 22.0616 5.477C22.4655 5.88093 22.6925 6.42876 22.6925 7C22.6925 7.57124 22.4655 8.11907 22.0616 8.523C21.6577 8.92692 21.1099 9.15385 20.5386 9.15385C19.9674 9.15385 19.4195 8.92692 19.0156 8.523C18.6117 8.11907 18.3848 7.57124 18.3848 7ZM8.23093 12.8462C7.6597 12.8462 7.11186 13.0731 6.70793 13.477C6.30401 13.8809 6.07709 14.4288 6.07709 15C6.07709 15.5712 6.30401 16.1191 6.70793 16.523C7.11186 16.9269 7.6597 17.1538 8.23093 17.1538C8.80217 17.1538 9.35001 16.9269 9.75393 16.523C10.1579 16.1191 10.3848 15.5712 10.3848 15C10.3848 14.4288 10.1579 13.8809 9.75393 13.477C9.35001 13.0731 8.80217 12.8462 8.23093 12.8462ZM20.5386 20.8462C19.9674 20.8462 19.4195 21.0731 19.0156 21.477C18.6117 21.8809 18.3848 22.4288 18.3848 23C18.3848 23.5712 18.6117 24.1191 19.0156 24.523C19.4195 24.9269 19.9674 25.1538 20.5386 25.1538C21.1099 25.1538 21.6577 24.9269 22.0616 24.523C22.4655 24.1191 22.6925 23.5712 22.6925 23C22.6925 22.4288 22.4655 21.8809 22.0616 21.477C21.6577 21.0731 21.1099 20.8462 20.5386 20.8462Z"
                fill="var(--c-primary)"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-gap-3 tw-pt-14" v-html="vars.jobDetailsHtml"></div>

      <div class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-6 tw-py-12">
        <h4 class="tw-uppercase">attachments</h4>
        <div class="tw-flex tw-w-full tw-items-center tw-gap-6">
          <nuxt-link
            v-for="attachment in attachments"
            :to="attachment.link"
            target="_blank"
            :external="true"
            class="n-btn n-primary outlined"
          >
            <div class="n-btn-container tw-w-full md:tw-w-auto">
              <div class="n-btn-group">
                <div class="n-btn-t1">{{ attachment.button_label }}</div>
                <div class="n-btn-t2">{{ attachment.button_label }}</div>
              </div>
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'JobDetail',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: { v1: 'v1' },
    };
  },
  computed: {
    features() {
      return this.groupedVariables.features;
    },

    attachments() {
      return this.groupedVariables.attachments;
    },
  },
});
</script>

<style scoped>
::v-deep h4 {
  font-weight: 500;
  font-size: 20px;
}

::v-deep ul {
  list-style: disc;
  padding-left: 20px;
}
</style>
